import { render, staticRenderFns } from "./Ai.vue?vue&type=template&id=2725ed72"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2725ed72')) {
      api.createRecord('2725ed72', component.options)
    } else {
      api.reload('2725ed72', component.options)
    }
    module.hot.accept("./Ai.vue?vue&type=template&id=2725ed72", function () {
      api.rerender('2725ed72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/fileExtensions/Ai.vue"
export default component.exports